<template>
  <a-form :form="form">
    <a-form-item>
      <a-checkbox-group
        v-model="ids"
        style="width: 100%"
        @change="selectChange"
      >
        <a-row :gutter="[6, 12]" style="overflow-y: auto; height: 60vh">
          <a-divider />
          <a-col v-for="item in items" :span="24" :key="item.id">
            <a-row :gutter="[6, 24]" type="flex" align="middle">
              <a-col :span="1">
                <a-checkbox :value="item.id"></a-checkbox>
              </a-col>
              <a-col :span="23">
                <a-row :gutter="6" type="flex" align="middle">
                  <a-col :span="2">
                    <img
                      :src="item.resourUrl | getImgPath"
                      width="50"
                      height="50"
                    />
                  </a-col>
                  <a-col :span="16">
                    <div class="title">
                      <a @click="openSelect(item)">{{ item.resourName }}</a>
                      <!--<a :href="item.resourUrl">{{ item.resourName }}</a>-->
                    </div>
                    <div class="detail">
                      <span>
                        <a-icon class="icon" type="apartment" />{{
                          item.deptName
                        }}
                      </span>
                      <span>
                        <a-icon class="icon" type="user" />{{
                          item.name ? item.name : item.userName
                        }}
                      </span>
                      <span>
                        <a-icon class="icon" type="clock-circle" />{{
                          moment(item.createdTime)
                        }}
                      </span>
                      <span>
                        <a-icon class="icon" type="download" />{{
                          item.downNum && item.downNum
                        }}
                      </span>
                    </div>
                  </a-col>
                  <a-col :span="6">
                    <a-button
                      type="primary"
                      style="margin-left: 8px"
                      @click="downLoadSelect(item.id)"
                      >下载
                    </a-button>
                  </a-col>
                </a-row>
              </a-col>
              <a-divider />
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>
    </a-form-item>
  </a-form>
</template>
<script>
import { download } from "@/api/base/resource/manager";
import { getImgPath } from "@components/_util/util";
import moment from "moment";
import fileDownload from "js-file-download";
import { axios } from "../../utils/request";

export default {
  props: {
    items: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },

  data() {
    return {
      // form
      form: this.$form.createForm(this),
      ids: []
    };
  },

  filters: {
    getImgPath: t => getImgPath(t)
  },

  methods: {
    selectChange(selectedKeys) {
      console.log(selectedKeys);
      this.$emit("idsChange", selectedKeys.toString());
    },

    openSelect(file) {
      // console.log(" === openSelect === ", file);

      // this.$emit("spin", true);
      // preview({ id: file.resourId }).then(res => {
      //   if (res.resultCode == 1) window.open(res.message);
      //   else this.$notification.error({ message: res.message });
      //   this.$emit("spin", false);
      // });

      //let url = file.resourUrl;
      //window.open('http://168.168.168.121:8012/onlinePreview?url=' + encodeURIComponent(window.btoa(url)));
      //window.open('http://mp.jtit.com.cn:8012/onlinePreview?url=' + encodeURIComponent(window.btoa(url)));

      // let url = `${process.env.VUE_APP_DOC_PREVIEW_HOST}:${
      //   process.env.VUE_APP_DOC_PREVIEW_PORT
      // }${
      //   process.env.VUE_APP_DOC_PREVIEW_URL
      // }/onlinePreview?url=${encodeURIComponent(window.btoa(file.resourUrl))}`;

      let url = `${process.env.VUE_APP_DOC_PREVIEW_DOMAIN}${
        process.env.VUE_APP_DOC_PREVIEW_URL
      }/onlinePreview?url=${encodeURIComponent(window.btoa(file.resourUrl))}`;
      window.open(url);
    },

    downLoadSelect(selectid) {
      console.log("下载选择", selectid);
      // 下载资源
      let data = { id: selectid };
      download({ ...data }).then(res => {
        if (res.resultCode === 1) {
          // console.log("传回对象：", res.result);

          let url = res.result.resourUrl;
          let resourceName = res.result.resourName;
          let message = res.message;
          // window.open(url);

          // 返回的数据类型
          axios.get(url, { responseType: "blob" }).then(res => {
            fileDownload(res, resourceName);
            this.$notification.success({
              message: message
            });
          });
        } else {
          this.$notification.error({
            message: res.message
          });
        }
      });
    },

    // 日期格式化
    moment(v) {
      return moment(v).format("YYYY-MM-DD");
    }
  }
};
</script>
<style lang="less" scoped>
.title {
  font-size: 18px;
  font-weight: bold;
}

.detail {
  color: rgba(#000, 0.45);

  > span {
    margin-right: 16px;
  }

  .icon {
    margin-right: 6px;
  }
}

/deep/ .ant-divider-horizontal {
  margin: 12px 0;
}
</style>
